// Puente JS de los tokens de marca. Los valores viven en styles/tokens.css:
// aquí solo se referencian, nunca se duplican.

export const C = {
  bg: 'var(--soha-marfil)',
  bg2: 'var(--soha-arena)',
  ink: 'var(--soha-carbon)',
  ink60: 'var(--soha-carbon-60)',
  ink40: 'var(--soha-carbon-40)',
  line: 'var(--soha-filete)',
  lineGold: 'var(--soha-filete-dorado)',
  accent: 'var(--soha-verde)',
  accentDeep: 'var(--soha-verde-profundo)',
  gold: 'var(--soha-dorado)',
  stone: 'var(--soha-piedra)',
  linen: 'var(--soha-marfil)',
  linen92: 'var(--soha-marfil-92)',
  linen82: 'var(--soha-marfil-82)',
  linen65: 'var(--soha-marfil-65)',
  linen45: 'var(--soha-marfil-45)',
  linen30: 'var(--soha-marfil-30)',
  linen15: 'var(--soha-marfil-15)',
  scrim72: 'var(--soha-carbon-72)',
  scrim55: 'var(--soha-carbon-55)',
  scrim28: 'var(--soha-carbon-28)',
  scrim25: 'var(--soha-carbon-25)',
  scrim15: 'var(--soha-carbon-15)',
  scrim0: 'var(--soha-carbon-00)',
};

export const SERIF = 'var(--soha-serif)';
export const SANS = 'var(--soha-sans)';
export const MONO = 'var(--soha-mono)';

export const TRACK = {
  eyebrow: 'var(--soha-track-eyebrow)',
  caption: 'var(--soha-track-caption)',
  h1: 'var(--soha-track-h1)',
};

export const MEDIDA = 'var(--soha-medida)';
export const EASE = 'var(--soha-ease)';
export const FOTO = 'var(--soha-foto-filtro)';
